import { GridComparatorFn } from '@mui/x-data-grid'

export const getClientAssetId = (
  identifyingInformation:
    | {
        [key: string]: string | number
      }
    | null
    | undefined,
  defaultIfNull = '',
): string | number | null => {
  if (identifyingInformation && identifyingInformation['Asset ID'])
    return identifyingInformation['Asset ID']

  return defaultIfNull
}

export const exposureComparator: GridComparatorFn<string> = (v1, v2) => {
  // All strings are equal, numbers are greater than strings.
  const n1 = Number.parseFloat(v1)
  const n2 = Number.parseFloat(v2)
  if (!Number.isNaN(n1) && !Number.isNaN(n2)) return n1 - n2
  if (!Number.isNaN(n1)) return 1
  if (!Number.isNaN(n2)) return -1
  return 0
}
